import {CreateTraineeRequest} from "@/api/api.clients"

export class CreateTraineeRequestModel implements CreateTraineeRequest{
    constructor(public userName: string, public  grade: number) {
    }
}
